import { Stack } from 'expo-router';

import { STATIC_NAVBAR_SCREEN_OPTIONS } from '../../../routing';

// ─────────────────────────────────────────────────────────────────────────────

export default function MenuDirectLinkLayout() {
  return <Stack screenOptions={STATIC_NAVBAR_SCREEN_OPTIONS} />;
}
